/**
 * Safe-area terms for app chrome, in Capacitor 8's prescribed form.
 *
 * Under edge-to-edge (#232) the WebView's own `env(safe-area-inset-*)` is not
 * trustworthy — Chromium 140 reports wrong values — so Capacitor publishes the
 * real insets as CSS custom properties and asks call sites to read those first,
 * falling back to `env()` and finally to `0px`. A bare `env()` call site is the
 * bug this shape exists to prevent, so it is written once here and imported.
 *
 * It lives in `styles/` rather than in `map/` because the Footer and the Layout
 * need it too, and app-wide chrome must not depend on the map. That dependency
 * is exactly why `Footer.jsx` hand-copied the string instead of importing it,
 * and the copy then sat unguarded: a tidy-up to a bare `env()` there kept the
 * whole suite green while reintroducing the Android defect on every route.
 * `map/safeArea.js` re-exports these so existing map imports are unchanged.
 */
export const SAFE_TOP = 'var(--safe-area-inset-top, env(safe-area-inset-top, 0px))';
export const SAFE_BOTTOM = 'var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px))';
